import $ from "jquery"

$(".main-search-button")
    .on("click",
        function (e) {
            e.preventDefault();
            $(".form").submit();
        });

$(".main-search")
    .on("submit",
        function (e) {
            e.preventDefault();
            var url = $(this).attr('action');
            var q = $("[name=q]").val();
            if (q !== '') {
                q = formatQuery(q);

                location.href = url + "?q=" + q;
            }
        });

$(".error-search-button")
    .on("click",
        function (e) {
            $("#errorSearchForm").submit();
        });

$(".error-search")
    .on("submit",
        function (e) {
            e.preventDefault();
            var url = $(this).attr('action');
            var q = $("#query").val();
            if (q !== '') {
                q = formatQuery(q);

                location.href = url + "?q=" + q;
            }
        });

//function for Search Button on ItemNotFound.cshtml
$("#searchButton").on("click",
    function (e) {
        e.preventDefault();
        let query = $("#query").val();
        if (query !== "") {
            let url = $("#errorSearchForm").attr("action");

            query = formatQuery(query);


            location.href = url + "?q=" + query;
            $("#errorSearchForm").submit();
        }
    });

//Function for Search button on mobile-layout
$("#search-mobile-button").on("click",
    function (e) {
        e.preventDefault();
        let url = $("#search-form-mobile").attr("action");
        let query = $("#input-mobile-search").val();

        console.log(`url: ${url}`);
        console.log(`query: ${query}`);

        query = formatQuery(query);

        location.href = url + "?q=" + query;
        $("#search-form-mobile").submit();

    });

$("input[name='q']").on('keypress', e => {
    if (e.which == 13) {
        e.preventDefault();

        var url = $("#searchLayer .form").attr('action');
        var query = getSearchQuery();

        query = formatQuery(query);
        location.href = url + "?q=" + query;

    }
});

$("#searchLayer .button--search").on("click",
    function (e) {
        e.preventDefault();

        var url = $("#searchLayer .form").attr('action');
        var query = getSearchQuery();

        query = formatQuery(query);
        location.href = url + "?q=" + query;

    });

//Helper function for handling spaces correctly in search result page
function formatQuery(query) {
    return query.replace(' ', '%20');
}

function getSearchQuery() {
    var desktopSearchStr = document.querySelector("#q-desktop").value;
    var mobileSearchStr = document.querySelector("#q-mobile") != undefined ? document.querySelector("#q-mobile").value : undefined;

    if (mobileSearchStr)
        return mobileSearchStr;
    if (desktopSearchStr)
        return desktopSearchStr;

    return "";

}


// WEBPACK FOOTER //
// ./Scripts/Search/sitesearch.js